import React, { useMemo } from 'react';
import useLeadsHandledByAttorney from '../../common/useLeadsHandledByAttorney.js';
import Spinner from '../spinner.js';
import Center from '../center.js';
import { SelectField } from '../../common/form.js';
import { Link } from 'react-router-dom';

const ErrorBanner = ({ errorMessage }) => {
    return (
        <div style={{ background: 'rgb(255, 192, 192)', padding: 10 }}>
            {errorMessage}
        </div>
    );
};

const UnexpectedErrorBanner = () => {
    return (
        <ErrorBanner errorMessage="Unexpected error. Please try again or report this problem, if it persists." />
    );
};

const LeadsList = ({ attorneyUserId }) => {
    const {
        leads,
        initialized,
        errorMessage,
        loading,
    } = useLeadsHandledByAttorney({ attorneyUserId });

    if (!initialized || loading) {
        return (
            <Center>
                <Spinner />
            </Center>
        );
    }
    if (errorMessage) {
        return <ErrorBanner errorMessage={errorMessage} />;
    }
    if (!leads) {
        return <UnexpectedErrorBanner />;
    }
    if (leads.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: 20, color: 'gray' }}>
                No leads found for this Contract Attorney in the current year.
            </div>
        );
    }

    return (
        <div style={{ marginTop: 20, background: 'white', borderRadius: 8, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                <thead>
                    <tr style={{ borderBottom: '2px solid #eee' }}>
                        <th style={{ padding: '10px 0' }}>Name</th>
                        <th style={{ padding: '10px 0' }}>Recommendation</th>
                        <th style={{ padding: '10px 0' }}>Changed?</th>
                        <th style={{ padding: '10px 0' }}>Original Rec.</th>
                        <th style={{ padding: '10px 0' }}>Status</th>
                        <th style={{ padding: '10px 0' }}>Opportunity Stage</th>
                        <th style={{ padding: '10px 0' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {leads.map((lead) => (
                        <tr key={lead.id} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '10px 0' }}>{lead.name}</td>
                            <td style={{ padding: '10px 0' }}>{lead.consultRecommendation || 'None'}</td>
                            <td style={{ padding: '10px 0' }}>
                                {lead.recommendationChanged ? (
                                    <span style={{
                                        background: '#fff3cd',
                                        color: '#856404',
                                        border: '1px solid #ffc107',
                                        borderRadius: 4,
                                        padding: '2px 8px',
                                        fontSize: 12,
                                        fontWeight: 600,
                                    }}>Yes</span>
                                ) : (
                                    <span style={{ color: '#6c757d', fontSize: 12 }}>No</span>
                                )}
                            </td>
                            <td style={{ padding: '10px 0', color: lead.recommendationChanged ? '#856404' : 'inherit' }}>
                                {lead.originalRecommendation || '—'}
                            </td>
                            <td style={{ padding: '10px 0' }}>{lead.status || 'N/A'}</td>
                            <td style={{ padding: '10px 0' }}>{lead.opportunityStage || 'N/A'}</td>
                            <td style={{ padding: '10px 0' }}>
                                <Link to={`/leads/${lead.id}`} style={{ color: '#007bff', textDecoration: 'none' }}>
                                    View Lead
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const ContractAttorneySection = ({ contractAttorneyUsers, attorneyUserId, setAttorneyUserId }) => {
    const attorneysAsOptions = useMemo(() => {
        return contractAttorneyUsers.map((user) => ({ value: user.user_id, label: user.name }));
    }, [contractAttorneyUsers]);

    if (contractAttorneyUsers.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: 20, color: 'gray' }}>
                No contract attorneys found in the system.
            </div>
        );
    }

    return (
        <>
            <div style={{ marginBottom: 15 }}>
                <SelectField
                    options={attorneysAsOptions}
                    value={attorneyUserId}
                    onChange={(selectedUserId) => setAttorneyUserId(selectedUserId)}
                />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <LeadsList attorneyUserId={attorneyUserId} />
            </div>
        </>
    );
};

export default ContractAttorneySection;
